require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-best-coding-bootcamp-award-fifth-consecutive-year.json") })
        }
      }, "path---blog-best-coding-bootcamp-award-fifth-consecutive-year");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-best-coding-bootcamp-award-fifth-consecutive-year!./.cache/json/blog-best-coding-bootcamp-award-fifth-consecutive-year.json
// module id = 721
// module chunks = 231608221292675